function getHalfOfYear() {
  const now = new Date();
  const month = now.getMonth() + 1;
  if (month >= 1 && month <= 6) {
      return '上半期';
  } else {
      return '下半期';
  }
}
function getDayOfMonth() {
        const now = new Date();
        now.setDate(now.getDate() + 1);
        let strDate = '';
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        strDate = `${firstDay.getMonth() + 1}.${firstDay.getDate()} - ${lastDay.getMonth() + 1}.${lastDay.getDate()}`;
        return strDate;
    }
    getDayOfMonth();

    const monthyDate = document.querySelector('.monthy__title--date');
    if(monthyDate){
      monthyDate.textContent = getHalfOfYear();
    }

    const listButton = document.querySelectorAll('.monthy__blocks .animal-button');
    [...listButton].forEach(item => item.addEventListener('click', handleClickButton));
    function handleClickButton(e) {
        const listAnimalButton = e.target.parentNode.parentNode.parentNode.querySelectorAll('.animal-button');
        const listBlockBottom = e.target.parentNode.parentNode.parentNode.querySelectorAll('.block-animal--bottom');
        const listBlockAnimal = e.target.parentNode.parentNode.parentNode.querySelectorAll('.block-animal');
        let itemSibling = e.target.parentNode.nextElementSibling;
        [...listAnimalButton].forEach(item => {
            if (item !== e.target) {
                item.classList.remove('animal-button-click');
            }
        });
        e.target.classList.toggle('animal-button-click');
        [...listBlockAnimal].forEach(item => {
            item.style = "margin-bottom:unset";
            if (e.target.parentNode.parentNode !== item) {
                item.classList.remove("block-active");
            }
        });
        itemSibling.classList.toggle('d-block');
        window.addEventListener('resize', () => {
            itemSibling.parentNode.style = `margin-bottom: ${itemSibling.offsetHeight}px`;
        })
        itemSibling.parentNode.style = `margin-bottom: ${itemSibling.offsetHeight}px`;
        itemSibling.parentNode.classList.toggle('block-active');
        [...listBlockBottom].forEach(item => {
            if (item !== itemSibling) {
                item.classList.remove('d-block');
            }
        });

    }



function handleChooseTime(){
  const form = document.querySelector('.wp-destiny .form-select');
  const result = document.querySelector('.form_result');
  let numYear,numMonth,numDate;
  numDate =  new Date().getDate();
    // console.log(numDate);
  function rendSelectYear(startYear) {
    numYear =  new Date().getFullYear();
     this.selectYear = document.querySelector('#year');
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;
    while (currentYear >= startYear) {
        const option = document.createElement('option');
        option.setAttribute('value', currentYear);
        option.text = currentYear;
      
        this.selectYear.appendChild(option);
        years.push(currentYear--);
    }
    // years[currentYear].setAttribute('selected', 'selected');
    // form.appendChild(this.selectYear);
  }
  function rendSelectMonth() {
    numMonth =  new Date().getMonth() +1;
    const currenTime = new Date();
     this.selectMonth = document.querySelector('#month');
    for (let i = 1; i <= 12; i++) {
        const option = document.createElement('option');
        option.setAttribute('value', i);
        option.text = i;
        if (i == currenTime.getMonth() + 1) { option.setAttribute('selected', 'selected') };
        this.selectMonth.appendChild(option);
    }
  }
  function rendDays(time) {
    this.selectDays = document.querySelector('#date');
       // numDate =  new Date().getDate();
      if(this.selectDays.value){
         numDate =  this.selectDays.value
      }
       // numDate =  new Date().getDate();
    // this.selectDays = document.querySelector('#date');
     this.selectDays.innerHTML ='';
    const currenTime = time ? new Date(time) : new Date();
    const month = currenTime.getMonth();
    const days = new Date(currenTime.getFullYear(), month + 1, 0);
    for (let i = 1; i <= days.getDate(); i++) {
        const option = document.createElement('option');
        option.setAttribute('value', i);
        option.text = i;
        if (i == currenTime.getDate()) { option.setAttribute('selected', 'selected') };
        this.selectDays.appendChild(option);
    }
    return currenTime;
  }
  rendDays();
  rendSelectYear(1950);
  rendSelectMonth();
    this.selectYear.addEventListener('change',function(){
        numYear = this.value;
        handleChange();
    
    });
    this.selectMonth.addEventListener('change',function(){
        numMonth = this.value;
        handleChange();
    });
    this.selectDays.addEventListener('change',function(){
        numDate = this.value;
        handleChange();
    });
  function handleChange(){
   rendDays(`"${numYear}-${numMonth}-${numDate}"`);
  }
   form && form.addEventListener('submit',(e)=> {
    e.preventDefault();
    numYear = this.selectYear.value;
    numMonth = this.selectMonth.value;
    numDate = this.selectDays.value;
   const times = new Date(`"${numYear}-${numMonth}-${numDate}"`);
   var weekdays = new Array();
    weekdays[0] = "Sunday";
    weekdays[1] = "Monday";
    weekdays[2] = "Tuesday";
    weekdays[3] = "Wednesday";
    weekdays[4] = "Thursday";
    weekdays[5] = "Friday";
    weekdays[6] = "Saturday";
    result.innerHTML = `Your birth number is <span>${weekdays[times.getDay()]}</span>`;
});
  const form2 = document.querySelector(".wp-numerology .form-select") ;
  form2 && form2.addEventListener('submit',(e)=> {
    e.preventDefault();
    // const number = randomIntFromInterval(1, 9);
    // result.innerHTML = `Your birth number is <span>${number}</span>`;
    var str = "" + numYear + numMonth + numDate;
    while(str.length > 1)
    {
      var n;
      var num = 0;
      var ary = str.split('');
      while(n = ary.pop()){ num += (n-0); }
      str = "" + num;
    }
    result.innerHTML = `Your birth number is <span>${(str != 0)? str : " "}</span>`;
    // result.textContent = (str != 0)? str : " ";
  });
  function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
}
handleChooseTime();



